import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  setInvisibleDashboardSummaryJob,
  getDashboardSummaryJobs,
  fetchDashboardSummaryJobStatus
} from 'src/reducers/employees/employeePays';
import { Close } from 'jbc-front/components/icons';
import { JobSuccess, JobFailed, JobInprogress } from 'src/components/JobStatus';
import { INITIAL_POLLING_INTERVAL, MAX_POLLING_INTERVAL } from 'src/constants/Generals';
import styles from './DashboardSummaryJobStatus.scss';

const TaskResult = ({ tasks, status, hideJobNotifications }) => {
  const { t } = useTranslation();
  let statusText = t('features.EmployeePays.components.DashboardSummaryJobStatus.dashboard_summary_process_is_complete');
  let tasksStyle = styles.tasksSuccess;

  if (status === 'failed') {
    statusText = t('features.EmployeePays.components.DashboardSummaryJobStatus.dashboard_summary_process_is_failed');
    tasksStyle = styles.tasksFailed;
  } else if (status === 'inProgress' || status === 'waiting') {
    statusText = t('features.EmployeePays.components.DashboardSummaryJobStatus.dashboard_summary_process_is_in_process');
    tasksStyle = styles.tasksInprogress;
  }

  return (
    <React.Fragment>
      {tasks &&
        tasks.length > 0 && (
          <div className={tasksStyle}>
            <div className={styles.inner}>
              {status === 'success' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideJobNotifications(tasks)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>
                    {tasks.map(task => <JobSuccess key={task.id} {...task} statusText={statusText} />)}
                  </ul>
                </React.Fragment>
              )}
              {status === 'failed' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideJobNotifications(tasks)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>
                    {tasks.map(task => <JobFailed key={task.id} {...task} statusText={statusText} />)}
                  </ul>
                </React.Fragment>
              )}
              {(status === 'inProgress' || status === 'waiting') && (
                <React.Fragment>
                  <ul className={styles.list}>
                    {tasks.map(task => <JobInprogress key={task.id} {...task} statusText={statusText} />)}
                  </ul>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
      {isEmpty(tasks) && null}
    </React.Fragment>
  );
};

class DashboardSummaryJobStatus extends React.Component {
  componentDidMount() {
    const { fetchVisibleDashboardSummaryJobs } = this.props;
    fetchVisibleDashboardSummaryJobs();
    this.pollFetchVisibleDashboardSummaryJobs(INITIAL_POLLING_INTERVAL);
  }

  pollFetchVisibleDashboardSummaryJobs = interval => {
    const { fetchVisibleDashboardSummaryJobs, dashboardSummaryJobs } = this.props;
    let newInterval = interval;
    if (
      dashboardSummaryJobs &&
      (Object.keys(dashboardSummaryJobs).includes('inProgress') ||
        Object.keys(dashboardSummaryJobs).includes('waiting'))
    ) {
      fetchVisibleDashboardSummaryJobs();
      if (newInterval < MAX_POLLING_INTERVAL) {
        newInterval *= 2;
      }
    } else {
      fetchVisibleDashboardSummaryJobs();
    }

    setTimeout(this.pollFetchVisibleDashboardSummaryJobs, newInterval, newInterval);
  };

  render() {
    const { dashboardSummaryJobs = {}, hideJobNotifications } = this.props;

    return (
      <React.Fragment>
        {isEmpty(dashboardSummaryJobs) ? null : (
          <div>
            {Object.keys(dashboardSummaryJobs).map(status => (
              <TaskResult
                key={status}
                tasks={dashboardSummaryJobs[status]}
                status={status}
                hideJobNotifications={hideJobNotifications}
              />
            ))}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  dashboardSummaryJobs: getDashboardSummaryJobs(state) || {}
});

const mapDispatchToProps = dispatch => ({
  fetchVisibleDashboardSummaryJobs: () => dispatch(fetchDashboardSummaryJobStatus(true)),
  hideJobNotifications: tasks => {
    const taskIds = tasks.map(t => t.id).join('_');
    if (taskIds.length > 0) {
      dispatch(setInvisibleDashboardSummaryJob(taskIds));
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSummaryJobStatus);
